// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1806":"a57bc515","3897":"6b1fe67a","8303":"47817980"}[chunkId] + ".chunk.css";
};